function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 16,
  cy: 16,
  r: 16
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "dax-flag-canada",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 28,
  y: 5,
  width: 4,
  height: 22
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 0,
  y: 5,
  width: 4,
  height: 22
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5363866,26.1458996 L15.7387484,21.9012006 C15.7518982,21.6253715 15.5389547,21.3911078 15.2631256,21.3779579 C15.2279931,21.376283 15.1927819,21.3783198 15.1580769,21.3840346 L10.9175463,22.0823038 L11.4456933,20.5961471 C11.5166364,20.3965199 11.4540679,20.1738526 11.2895294,20.0403946 L6.70467338,16.3215954 L7.60733702,15.8899828 C7.83223278,15.7824478 7.94356319,15.5256832 7.86834141,15.2880205 L7.00586766,12.5630408 L9.57575882,13.0853977 C9.80471147,13.1319347 10.0353698,13.0137142 10.1312798,12.8006736 L10.6259317,11.7019254 L12.301253,13.5620735 C12.4860548,13.7672634 12.8022056,13.7837911 13.0073955,13.5989892 C13.1388179,13.480625 13.1979295,13.3016362 13.1628473,13.1282834 L12.1936808,8.33930585 L13.7052057,9.28439173 C13.9393473,9.43078954 14.2478355,9.35965913 14.3942333,9.12551752 C14.4017551,9.11348743 14.4087615,9.10114262 14.4152334,9.08851663 L16,5.99680939 L17.5847666,9.08851663 C17.5912385,9.10114262 17.5982449,9.11348743 17.6057667,9.12551752 C17.7521645,9.35965913 18.0606527,9.43078954 18.2947943,9.28439173 L18.2947943,9.28439173 L19.8063192,8.33930585 L18.8371527,13.1282834 C18.8020705,13.3016362 18.8611821,13.480625 18.9926045,13.5989892 C19.1977944,13.7837911 19.5139452,13.7672634 19.698747,13.5620735 L19.698747,13.5620735 L21.3740683,11.7019254 L21.8687202,12.8006736 C21.9646302,13.0137142 22.1952885,13.1319347 22.4242412,13.0853977 L22.4242412,13.0853977 L24.9941323,12.5630408 L24.1316586,15.2880205 C24.0564368,15.5256832 24.1677672,15.7824478 24.392663,15.8899828 L24.392663,15.8899828 L25.2953266,16.3215954 L20.7104706,20.0403946 C20.5459321,20.1738526 20.4833636,20.3965199 20.5543067,20.5961471 L20.5543067,20.5961471 L21.0824537,22.0823038 L16.8419231,21.3840346 C16.8072181,21.3783198 16.7720069,21.376283 16.7368744,21.3779579 C16.4610453,21.3911078 16.2481018,21.6253715 16.2612516,21.9012006 L16.2612516,21.9012006 L16.4636134,26.1458996 L15.5363866,26.1458996 Z",
  id: "Combined-Shape",
  fill: "#C20000",
  mask: "url(#mask-2)"
}));

function SvgDaxFlagCanada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Canada") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxFlagCanada);
export default __webpack_public_path__ + "static/media/dax-flag-canada.926ed27e.svg";
export { ForwardRef as ReactComponent };